import { Box, Button, Link, Grid, makeStyles, useTheme, useMediaQuery, Theme } from "@material-ui/core";
import {
  SwyftEmailLink,
  SwyftEmail,
  SwyftContactPhoneNumberLink,
  SwyftContactPhoneNumberWhatsAppLink,
  SwyftContactCorkPhoneNumber,
  SwyftContactCorkPhoneNumberLink,
  SwyftContactDublinPhoneNumber,
  SwyftContactDublinPhoneNumberLink
} from "../../../app/consts";
import { isMobile } from "react-device-detect";
import { TF } from "../../../components/typography/TF";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import SmartphoneIcon from "@material-ui/icons/Smartphone";

const QuoteTopHelp = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));

  let emailUs = function () {
    if (isMobile) {
      return null;
    }

    return (
      <Grid item xs={6}>
        <Box textAlign="left">
          <Link href={SwyftEmailLink}>
            <MailOutlineIcon />
            <TF bold upperCase color="secondary" component="span">
              {SwyftEmail}
            </TF>
          </Link>
        </Box>
      </Grid>
    );
  };

  let phoneUs = function () {
    if (isMobile) {
      return null;
    }

    return (
      <Grid item xs={6}>
        <Box display="flex">
          <Box>
            <SmartphoneIcon />
          </Box>
          <Box textAlign="left">
            <TF gutterBottom>
              Cork:&nbsp;&nbsp;&nbsp; <Link href={SwyftContactCorkPhoneNumberLink}>{SwyftContactCorkPhoneNumber}</Link>
            </TF>
            <TF gutterBottom>
              Dublin: <Link href={SwyftContactDublinPhoneNumberLink}>{SwyftContactDublinPhoneNumber}</Link>
            </TF>
          </Box>
        </Box>
      </Grid>
    );
  };

  let callUs = function () {
    if (!isMobile) {
      return null;
    }

    return (
      <Box mt={2}>
        <Grid container spacing={2} direction="row">
          <Grid item md={6} xs={12}>
            <Button
              href={SwyftContactPhoneNumberLink}
              variant="outlined"
              fullWidth
              color="secondary"
              className={classes.button}
            >
              Call Us Now
            </Button>
          </Grid>
          <Grid item md={6} xs={12}>
            <Button
              href={SwyftContactPhoneNumberWhatsAppLink}
              variant="outlined"
              color="secondary"
              className={classes.button}
              fullWidth
            >
              Chat via WhatsApp
            </Button>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const helpText = (
    <Box>
      <TF variant="h5" bold paragraph>
        Got a Question?
      </TF>
      <TF paragraph>
        If you have a question about any of the notes we have included, please call us immediately so we can address any
        concerns and our team can complete your installation hassle free.
      </TF>
    </Box>
  );

  return (
    <Box width={isSmall ? "100%" : "60%"} margin="auto" textAlign="center">
      {helpText}
      <Box width={isSmall ? "100%" : "80%"} margin="auto">
        <Grid container justifyContent="center">
          {emailUs()}
          {phoneUs()}
          <Grid item md={12} xs={12}>
            {callUs()}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default QuoteTopHelp;

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    "fontSize": "0.8rem",
    "fontWeight": "bold",
    '& [class*="Button-label"]': {
      justifyContent: "center"
    }
  }
}));
